import { decToHex2 } from './decToHex2';

export const randomHexBytes = (length: number) =>
  Array.from(crypto.getRandomValues(new Uint8Array(length)))
    .map(decToHex2)
    .join('');
